import { render, staticRenderFns } from "./Zixun.vue?vue&type=template&id=0264894a&scoped=true&"
import script from "./Zixun.vue?vue&type=script&lang=js&"
export * from "./Zixun.vue?vue&type=script&lang=js&"
import style0 from "./Zixun.vue?vue&type=style&index=0&id=0264894a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264894a",
  null
  
)

export default component.exports